import type { RouteLocationAsRelativeGeneric } from "vue-router";

export enum Layout {
  Default,
  LockingState,
}

declare module "vue-router" {
  interface RouteMeta {
    public?: boolean;
    title?: () => string;

    /**
     * Layout to use for this route.
     * Optional - when not set, the default layout will be used.
     */
    layout?: Layout;

    /**
     * If a logged-in user visits this route, should they be redirected elsewhere?
     * This is useful when we want to disable access to a public page for logged-in users.
     */
    redirectWhenLoggedIn?: RouteLocationAsRelativeGeneric;

    /**
     * Use this option to prevent the page from jumping to the top when URL changes but we're still
     * staying on the same page. Useful when updating URL after some on-page filter is changed -> we
     * don't want to scroll to top whenever the filter is changed.
     */
    preventScrollToTop?: boolean;

    allowNoCountryCode?: boolean;

    /**
     * A logged-out visitor is sent to log in and brought back afterwards. Login alone carries the
     * target in its URL; this also keeps it through registration and SSO sign-ins.
     */
    returnAfterRegistration?: boolean;

    /**
     * If set to true, will hide the big, complex footer and show a simple one instead.
     */
    renderSimpleFooter?: boolean;

    /**
     * We are slowly transitioning to using gray background for all pages.
     * Drop this option once all pages are using gray background.
     */
    grayBackground?: boolean;
  }
}
